import { render, staticRenderFns } from "./previewPDF.vue?vue&type=template&id=07a8d245&scoped=true"
import script from "./previewPDF.vue?vue&type=script&lang=js"
export * from "./previewPDF.vue?vue&type=script&lang=js"
import style0 from "./previewPDF.vue?vue&type=style&index=0&id=07a8d245&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a8d245",
  null
  
)

export default component.exports